import React from "react";
import Icon from '../../../dashboard/Icon/Icon';

const CustomLoader = (props) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        gap: "20px",
      }}
      {...props}
    >
      <Icon src={`assets/icons/lsq_casa_logo.svg`} alt="icon" />
      <div
        style={{
          width: "20%",
          height: "4px",
          backgroundColor: "rgb(var(--ng-neutral-10))",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <div
          style={{
            width: "30%",
            height: "100%",
            backgroundColor: "rgb(var(--ng-primary-40))",
            position: "absolute",
            left: "-30%",
            animation: "smooth-loading 2s cubic-bezier(0.4, 0.0, 0.2, 1) infinite",
          }}
        />
      </div>
      <style>
        {`
          @keyframes smooth-loading {
            0% {
              left: -30%;
            }
            50% {
              left: 100%; 
            }
            100% {
              left: 100%; 
            }
          }
        `}
      </style>
    </div>
  );
};

export default CustomLoader;
